import React, { createContext, useState, useContext, useEffect } from "react";

const CompanyContext = createContext();

export const useCompany = () => useContext(CompanyContext);

export const CompanyProvider = ({ children }) => {
    const [companyCredits, setCompanyCredits] = useState(0);
    const [companyName, setCompanyName] = useState("");
    const [companyId, setCompanyId] = useState("");

    const setCompanyData = ({ credits, name }) => {
        setCompanyCredits(credits);
        setCompanyName(name);
    };
    useEffect(() => {
        const storedUser = JSON.parse(localStorage.getItem("user"));
        if (storedUser.company) {
            setCompanyId(storedUser.company);
        }
    }, []);

    return (
        <CompanyContext.Provider
            value={{
                companyCredits,
                companyName,
                setCompanyData,
                setCompanyCredits,
                setCompanyName,
                companyId,
            }}
        >
            {children}
        </CompanyContext.Provider>
    );
};
